module.exports = "<cw-navbar></cw-navbar>\n<header class=\"secondary\"></header>\n<main>\n  <header>License</header>\n  <section class=\"row\">\n    <cxScrollable>\n      <p>...</p>\n    </cxScrollable>\n  </section>\n</main>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/license/license.component.html
// module id = 1665
// module chunks = 0